import ApiProvider  from './ApiProvider';
import { ActionStatusType } from '../types/ActionStatusType';

const TranslationsApi = {
  fetchTranslations: async () => {
    return await ApiProvider.get<ActionStatusType>(
      'Translation/GetGroupedTranslations'
    );
  },
  fetchUserLang: async () => {
    return await ApiProvider.get<ActionStatusType<string>>(
      'Translation/GetUserLang'
    );
  },
  changeLanguage: async (languageCode: string) => {
    return await ApiProvider.post<ActionStatusType>(
      'TopMenuModule/ChangeCurrentLanguage',
      languageCode
    );
  },
};

export default TranslationsApi;
